import { isAgentHubEnabled } from 'agentHub/selectors/agentHubSelectors'
import { MALDIVES_CHARTER_CONFIG } from 'constants/charterFlight'

const DEFAULT_AIRPORT_CODE = MALDIVES_CHARTER_CONFIG.DEPARTURE_AIRPORT

const WEEKDAYS = [0, 1, 2, 3, 4, 5, 6]

export const AGENT_HUB_MIN_CALENDAR_START_MONTH = 4

const enabledWeekdaysAirportMap: Record<string, Array<number>> = {
  MEL: [1], // Melbourne flights only depart on Mondays
  MLE: [0], // Maldives flights only depart on Sundays
}

export function getAgentHubFlightEnabledWeekdays(departureAirport?: App.AirportLocation): Array<number> {
  if (!departureAirport) return WEEKDAYS
  if (!isAgentHubEnabled) return WEEKDAYS
  return enabledWeekdaysAirportMap[departureAirport.airportCode] ?? WEEKDAYS
}

export function getAgentHubDefaultAirport(airports: Array<App.Airport>): App.Airport | undefined {
  const defaultAirport = airports.find(airport => airport.code === DEFAULT_AIRPORT_CODE)

  return defaultAirport
}
